import { ShimmerEffect } from "components/shimmer";
import { cn } from "utils";

export function ReviewByDayLoader({ cardCount = 3 }) {
  return (
    <div
      role="region"
      aria-label="Timesheet entries"
      className={"lg:py-6 py-4 lg:px-6 px-4 "}
    >
      <div className={"flex flex-col gap-6"}>
        <div className="flex justify-between md:items-center md:gap-6 gap-4 md:flex-row flex-col">
          <div>
            <ShimmerEffect className="w-40 h-6.5  " />
            <ShimmerEffect className="w-20 h-6.5 mt-2 " />
          </div>
          {/* <div className={"flex gap-3 md:flex-row flex-col-reverse"}>
            <div className="flex gap-6 justify-end items-center flex-row-reverse md:flex-row">
              <ShimmerEffect className="size-4.5 rounded-full " />
            </div>
          </div> */}
        </div>
      </div>
      <div className={"mt-4 flex gap-4.5"}>
        {Array.from({ length: cardCount }).map((_, cardIndex) => (
          <ShimmerEffect
            key={cardIndex}
            className={cn("flex-shrink-0 w-80 h-40 rounded-lg overflow-hidden")}
          />
        ))}

        <div className="sr-only">Loading timesheet entries...</div>
      </div>
    </div>
  );
}
